var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"weather-current"},[_c('h4',{staticClass:"dashboard-header"},[_vm._v(_vm._s(_vm.$t('weatherConditions')))]),_c('div',{staticClass:"weather-current__deck"},_vm._l((_vm.cards),function(card){return _c('WeatherCurrentCard',{key:`weather-current-${card.key}`,attrs:{"card":card}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }